/**
 * @generated SignedSource<<7773a802b9794d80e8de16a6eb36898b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BulkUpdatePhasePortalConfigInput = {
  phases: ReadonlyArray<PhasePortalConfigInput>;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type PhasePortalConfigInput = {
  psaMilestoneId: string;
  clientOrgId?: string | null;
  psaProjectId?: string | null;
  legacyPsaProjectId?: string | null;
  requiresClientSignoff?: boolean | null;
  signoffApproverForecastPersonId?: number | null;
  signoffApproverPortalUserId?: string | null;
};
export type bulkUpdatePhasePortalConfigMutation$variables = {
  input: BulkUpdatePhasePortalConfigInput;
};
export type bulkUpdatePhasePortalConfigMutation$data = {
  readonly bulkUpdatePhasePortalConfig: {
    readonly phases: ReadonlyArray<{
      readonly id: string;
      readonly portalConfig: {
        readonly requiresClientSignoff: boolean | null;
        readonly signoffApproverPortalUserId: string | null;
        readonly signoffLocked: boolean | null;
        readonly signoffLockedAt: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type bulkUpdatePhasePortalConfigMutation = {
  variables: bulkUpdatePhasePortalConfigMutation$variables;
  response: bulkUpdatePhasePortalConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkUpdatePhasePortalConfigPayload",
    "kind": "LinkedField",
    "name": "bulkUpdatePhasePortalConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseType",
        "kind": "LinkedField",
        "name": "phases",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PhasePortalConfig",
            "kind": "LinkedField",
            "name": "portalConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresClientSignoff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffApproverPortalUserId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffLocked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffLockedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkUpdatePhasePortalConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkUpdatePhasePortalConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "70dea14098c80dbd591106968764c047",
    "id": null,
    "metadata": {},
    "name": "bulkUpdatePhasePortalConfigMutation",
    "operationKind": "mutation",
    "text": "mutation bulkUpdatePhasePortalConfigMutation(\n  $input: BulkUpdatePhasePortalConfigInput!\n) {\n  bulkUpdatePhasePortalConfig(input: $input) {\n    phases {\n      id\n      portalConfig {\n        requiresClientSignoff\n        signoffApproverPortalUserId\n        signoffLocked\n        signoffLockedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c5035f8b00046c90ec0600f10ed949cd";

export default node;
